import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import styles from './ReviewConfirmation.module.scss'
import { editFromConfirmationAction } from 'redux/actions'
import { useDispatch } from 'react-redux'

const ChangeOfAddress = ({ t, i18n, setIsError, isMobile }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { addressUpdate } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      if (addressUpdate === '') {
        history.push(`/${i18n.language}${t('routes.contact_info')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const editAddressUpdateOnClick = () => {
    dispatch(editFromConfirmationAction(true))
    history.push(`/${i18n.language}${t('routes.contact_info')}`)
  }

  const headerColSpan = isMobile ? '2' : '1'
  const valueColSpan = isMobile ? '2' : '1'
  const actionColSpan = isMobile ? '1' : '3'

  return (
    // <table className={['table', styles['border_none']].join(' ')} style={{ tableLayout: "fixed" }}  >
    //   <tbody style={{ border: '1px solid black' }} >
    //     <tr>
    //       <td colSpan={headerColSpan}><strong className={styles['margin_bottom']}>{t('review_confirmation.change_of_address')}</strong></td>
    //       <td colSpan={valueColSpan}>{addressUpdate ? t('shared.yes') : t('shared.no')}</td>
    //       <td colSpan={actionColSpan}>
    //         <div className={styles['display_visible_desktop']} style={{ display: "flex", justifyContent: "flex-end", marginRight: "1rem" }}>
    //           <button
    //             className="btn-sm btn-default"
    //             style={{ margin: '0' }}
    //             onClick={editAddressUpdateOnClick}
    //             value={`driving school info ${t('review_confirmation.edit')}`}
    //             name={`driving school info ${t('review_confirmation.edit')}`}
    //           >
    //             {t('review_confirmation.edit')}
    //           </button>
    //         </div>
    //       </td>
    //     </tr>
    //   </tbody>
    // </table >

    <div className="row row-odd">
      <div className="col-xs-6">
        <strong>{t('review_confirmation.change_of_address')}</strong>
      </div>
      <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
        {addressUpdate ? t('shared.yes') : t('shared.no')}
        <a
          href="javascript:void(0);"
          className={[styles['edit_button_right']].join(' ')}
          onClick={editAddressUpdateOnClick}
          value={`driving school info ${t('review_confirmation.edit')}`}
          name={`driving school info ${t('review_confirmation.edit')}`}
        >
          {t('review_confirmation.edit')}
        </a>
      </div>
    </div>
  )
}

export default withTranslation('common')(ChangeOfAddress)
